module.exports = __webpack_public_path__ + "img/leather_gloves.8e434ba0.png";